// extracted by mini-css-extract-plugin
export var chatHtmlText = "_t2-2";
export var chatLink = "_t2-0";
export var chatText = "_t2-1";